import { Component, Inject } from '@angular/core';
import {  ReactiveFormsModule } from "@angular/forms";
import { LmsModalFrameComponent } from "@lmsSharedUI";
import { PreAuthorisationModel } from 'src/app/core/models/pre-authorisation.model';
import { MdbModalRef, MdbRadioModule } from 'src/lib/mdb5-adapted/public-api';

@Component({
  selector: 'app-switchdata',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    LmsModalFrameComponent,
    MdbRadioModule
  ],
  templateUrl: './switchdata.component.html',
  styleUrls: ['./switchdata.component.scss'],
})
export class SwitchdataComponent {
  preAuthModel = {} as PreAuthorisationModel;
  quoteWorkBook: any;

  selectedmodel: number;
  constructor(
    public dialogRef: MdbModalRef<SwitchdataComponent>,
    @Inject('data') data: any
    //private clientSearch: ClientDetailsService
  ) {
    this.selectedmodel == 0;
    this.quoteWorkBook = data.quoteWorkBook;
    this.preAuthModel = data.PreAuthModel;
  }

  continueApplication() {
    this.dialogRef.close(this.selectedmodel);
  }
  close() {
    this.dialogRef.close(); //this.postalDetailsForm.value??
  }
}
